var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6305 1.66162H3.75341C2.71505 1.66162 1.87329 2.59127 1.87329 3.73804V29.1621C1.87329 30.3089 2.71505 31.2385 3.75341 31.2385H37.6305C38.6689 31.2385 39.5106 30.3089 39.5106 29.1621V3.73804C39.5106 2.59127 38.6689 1.66162 37.6305 1.66162Z",
    stroke: "#16AF8E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87329 9.92377L19.1092 22.2278C20.0754 22.9183 21.3128 22.9183 22.2791 22.2278L39.515 9.92377",
    stroke: "#16AF8E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e2fbd89c5d87fc07ffac2e80a85955c0.svg";
export { ForwardRef as ReactComponent };